import { Checkbox } from "@volca/ui/components/ui/checkbox";

export const OPTION_SEARCH_THRESHOLD = 7;

const FILTER_ROW_CLASS =
  "flex w-full cursor-pointer items-center gap-2 rounded-md px-2 py-1.5 text-left transition-colors hover:bg-neutral-subtle-hovered";

const FilterRowCount = ({ count }: { count?: number }) =>
  count == null ? null : (
    <span className="shrink-0 text-xs text-subtle">{count}</span>
  );

interface FilterCheckRowProps {
  id: string;
  label: string;
  count?: number;
  checked: boolean;
  onToggle: () => void;
}

export const FilterCheckRow = ({
  id,
  label,
  count,
  checked,
  onToggle,
}: FilterCheckRowProps) => (
  <label htmlFor={id} className={FILTER_ROW_CLASS}>
    <Checkbox id={id} checked={checked} onCheckedChange={onToggle} />
    <span className="min-w-0 flex-1 truncate text-sm text-ink" title={label}>
      {label}
    </span>
    <FilterRowCount count={count} />
  </label>
);

export const toggleValue = <TValue,>(
  values: TValue[],
  value: TValue,
): TValue[] =>
  values.includes(value)
    ? values.filter((current) => current !== value)
    : [...values, value];
